import { RouteObject } from "../../interfaces/navigation";
import React from "react";

const EntryPoint = React.lazy(() => import("../../containers/Brands/BrandsContainer"));

export const brandsRoutes: RouteObject[] = [
    {
        title: "Brands",
        path: "/marcas-autos-0km",
        component: <EntryPoint/>
    }
];